import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  Columns,
  cellStyles4,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  dropDownMenuItemsAlphabets,
  dropDownMenuItemsValues,
} from '../../core-utils/helper-utils/tableSortHelper';
export const networkLeakagePageConstants = {
  piChartConstants: {
    data: [
      {
        label: 'Member Paid',
        value: '52.87',
        color: patientAccessTheme.palette.primary[300],
      },
      {
        label: 'Plan Paid',
        value: '41.01',
        color: patientAccessTheme.palette.primary[100],
      },
    ],

    inAndOutNetworkMessages: {
      TITLE: 'Network Usage',
      SUB_TITLE: ' ',
      CLICK_HERE: 'Click here',
      TOOLTIP: 'Showing percentile of the In Network',
    },

    inNetworkMessages: {
      TITLE: 'In-Network',
      SUB_TITLE: 'The total cost of In Network',
      CLICK_HERE: 'Click here',
      TOOLTIP: 'Showing percentile of the In Network',
    },
    outNetworkMessages: {
      TITLE: 'Out-of-Network',
      SUB_TITLE: 'The total cost of Out Network',
      CLICK_HERE: 'Click here',
      TOOLTIP: 'Showing percentile of the Out Network',
    },
    TOOLTIP_FOR_NETWORK_LEAKAGE_IMPACT:
      'Network Usage Impact shows the cost of care at in-network and out-of-network providers.  Out-of-network claims may be paid at a lesser discount and disproportionately impacting the plan as a whole.',
  },
  COHORT_DETAILS: {
    TITLE: 'Cohort Details',
    SUBTITLE:
      'Select the properties that you would like to apply to current data',
  },
  networkUtilizationChartConstants: {
    inMemberPaidData: [
      {
        value: '120340',
      },
      {
        value: '420340',
      },
      {
        value: '320340',
      },
      {
        value: '320340',
      },
      {
        value: '320340',
      },
      {
        value: '340340',
      },
      {
        value: '350340',
      },
      {
        value: '360340',
      },
      {
        value: '340340',
      },
      {
        value: '320340',
      },
      {
        value: '320340',
      },
      {
        value: '220340',
      },
    ],

    inPlanPaidData: [
      {
        value: '50000',
      },
      {
        value: '45000',
      },
      {
        value: '34000',
      },
      {
        value: '46000',
      },
      {
        value: '50000',
      },
      {
        value: '50000',
      },
      {
        value: '56000',
      },
      {
        value: '30000',
      },
      {
        value: '50000',
      },
      {
        value: '20000',
      },
      {
        value: '50000',
      },
      {
        value: '50000',
      },
    ],
    outMemberPaidData: [
      {
        value: '90000',
      },
      {
        value: '75000',
      },
      {
        value: '44000',
      },
      {
        value: '46000',
      },
      {
        value: '50000',
      },
      {
        value: '60000',
      },
      {
        value: '56000',
      },
      {
        value: '30000',
      },
      {
        value: '50000',
      },
      {
        value: '20000',
      },
      {
        value: '70000',
      },
      {
        value: '60000',
      },
    ],
    outPlanPaidData: [
      {
        value: '50000',
      },
      {
        value: '45000',
      },
      {
        value: '34000',
      },
      {
        value: '46000',
      },
      {
        value: '50000',
      },
      {
        value: '50000',
      },
      {
        value: '56000',
      },
      {
        value: '30000',
      },
      {
        value: '50000',
      },
      {
        value: '20000',
      },
      {
        value: '50000',
      },
      {
        value: '50000',
      },
    ],
  },
};
export const memberTableColumns: Columns[] = [
  {
    name: 'Name',
    align: 'left',
    cellStyles: cellStyles4,
    width: '350px',
    sortColumnName: 'providerName',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Type',
    align: 'left',
    cellStyles: cellStyles4,
    width: '200px',
    sortColumnName: 'providerType',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Claims',
    align: 'right',
    cellStyles: cellStyles4,
    width: '200px',
    sortColumnName: 'claims',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Total Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '200px',
    sortColumnName: 'totalCharge',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Member Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '200px',
    sortColumnName: 'memberPaid',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Plan Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '200px',
    sortColumnName: 'planPaid',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
];

export const rowData = [
  ['Community hospital', 'Facility', '13', '338k', '7.3k', '330k'],
  ['Ingeniorx specialty pharmacy', 'Provider', '13', '252k', '9.3k', '330k'],
  ['Tividad medical center', 'Provider', '13', '338k', '7.3k', '330k'],
];

export const networkUtilizationColumns: Columns[] = [
  {
    name: 'Month',
    align: 'left',
    cellStyles: cellStyles4,
    width: '',
  },
  {
    name: 'Member Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '',
    sortColumnName: 'inMemberPaid',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Plan Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '',
    sortColumnName: 'inPlanPaid',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
];
